"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    LESSON_FEEDBACK: 'lesson_feedback',
    LESSON_ABSENCE: 'lesson_absence',
    SESSION_FEEDBACK: 'session_feedback',
    SESSION_ABSENCE: 'session_absence',
};
//# sourceMappingURL=feedbackType.js.map